export type GamesSizeMode = "compact" | "comfort" | "full" | "custom";
export type GamesPanelSide = "left" | "right";

export const GAMES_COMPACT_WIDTH = 380;
export const GAMES_COMFORT_WIDTH = 520;
export const GAMES_MIN_WIDTH = 320;
export const GAMES_MAX_WIDTH = 720;
export const GAMES_SNAP_THRESHOLD = 40;

const PAGE_GUTTER = 32;
const MIN_CONTENT_WIDTH = 320;

export function gamesViewportMax(viewportWidth: number): number {
  const available = viewportWidth - PAGE_GUTTER - MIN_CONTENT_WIDTH;
  return Math.min(GAMES_MAX_WIDTH, Math.max(GAMES_MIN_WIDTH, available));
}

export function clampGamesWidth(width: number, viewportMax?: number): number {
  const max = viewportMax ?? GAMES_MAX_WIDTH;
  const n = Number(width);
  if (!Number.isFinite(n)) return GAMES_COMFORT_WIDTH;
  return Math.round(Math.min(max, Math.max(GAMES_MIN_WIDTH, n)));
}

export function snapWidthForMode(
  mode: Exclude<GamesSizeMode, "custom" | "full">,
  viewportWidth = typeof window === "undefined" ? 1280 : window.innerWidth
): number {
  const max = gamesViewportMax(viewportWidth);
  const target = mode === "compact" ? GAMES_COMPACT_WIDTH : GAMES_COMFORT_WIDTH;
  return clampGamesWidth(target, max);
}

/** Sürükleme bitince manyetik snap: compact / comfort, çok genişse full. */
export function snapGamesRelease(
  width: number,
  viewportWidth: number
): { width: number; mode: GamesSizeMode } {
  const max = gamesViewportMax(viewportWidth);
  const clamped = clampGamesWidth(width, max);

  if (clamped >= max * 0.88) {
    return { width: clamped, mode: "full" };
  }

  const compact = snapWidthForMode("compact", viewportWidth);
  const comfort = snapWidthForMode("comfort", viewportWidth);

  if (Math.abs(clamped - compact) <= GAMES_SNAP_THRESHOLD) {
    return { width: compact, mode: "compact" };
  }
  if (Math.abs(clamped - comfort) <= GAMES_SNAP_THRESHOLD) {
    return { width: comfort, mode: "comfort" };
  }

  return { width: clamped, mode: "custom" };
}

export function snapPanelSide(
  clientX: number,
  viewportWidth: number
): GamesPanelSide {
  return clientX < viewportWidth / 2 ? "left" : "right";
}
